import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 pt-20">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-background-100">
            <i className="ri-movie-line text-3xl text-foreground-400" />
          </div>
          <h1 className="text-4xl font-bold font-heading text-foreground-900 mb-4">
            404
          </h1>
          <h2 className="text-xl font-medium text-foreground-700 mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-foreground-500 mb-8">
            {t('notFound.description')}
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('notFound.backHome')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}